import { handleGetRequest, handlePostRequest } from "../hooks/api";

export async function createMarketPulseArticle(payload) {
  const endpoint = "/article/market-pulse/create";
  const response = await handlePostRequest(endpoint, payload, undefined);
  if (response.error) {
    throw new Error(response.error);
  }
  return response.data;
}

export async function listMarketPulseArticle(
  payload = { offset: 0, limit: 10 }
) {
  const endpoint = `/article/market-pulse/list?offset=${payload.offset}&limit=${
    payload.limit
  }`;

  const response = await handleGetRequest(endpoint, payload, {});
  if (response.error) {
    throw new Error(response.error);
  }
  return response.data;
}

export async function getMarketPulseArticle(pulseId) {
  const endpoint = `/article/market-pulse/detail/${pulseId}`;
  const response = await handleGetRequest(endpoint, undefined);
  if (response.error) {
    throw new Error(response.error);
  }
  return response.data;
}

/* Starging gallyo sentiment section */

export async function createGallyoSentimentArticle(payload) {
  const endpoint = "/article/gallyo-sentiment/create";
  const response = await handlePostRequest(endpoint, payload, undefined);
  if (response.error) {
    throw new Error(response.error);
  }
  return response.data;
}

export async function listGallyoSentimentArticle(
  payload = { offset: 0, limit: 10 }
) {
  const endpoint = `/article/gallyo-sentiment/list?offset=${
    payload.offset
  }&limit=${payload.limit}`;
  const response = await handleGetRequest(endpoint, payload, undefined);
  if (response.error) {
    throw new Error(response.error);
  }
  return response.data;
}

export async function getGallyoSentimentArticle(sentimentId) {
  const endpoint = `/article/gallyo-sentiment/detail/${sentimentId}`;
  const response = await handleGetRequest(endpoint, undefined);
  if (response.error) {
    throw new Error(response.error);
  }
  return response.data;
}
